import React from 'react';
import {
  ApiFilled,
  ApiOutlined,
  ImportOutlined,
  ReconciliationOutlined,
} from '@ant-design/icons';

import ApiConnectionsContainer from '@totem/components/administration/apiConnections/ApiConnectionsContainer';
import ApiConnectionsLayout, {
  ApiConnectionsExtra,
} from '@totem/components/administration/apiConnections/ApiConnectionsLayout';
import ApiSitesContainer from '@totem/components/administration/apiSites/ApiSitesContainer';
import ApiSitesLayout, {
  ApiSitesExtra,
} from '@totem/components/administration/apiSites/ApiSitesLayout';
import { logSyncContainerConfiguration } from '@totem/components/administration/logSync/containerConfiguration';
import LogSyncContainer from '@totem/components/administration/logSync/LogSyncContainer';
import {
  LogSyncExtra,
  LogSyncLayout,
} from '@totem/components/administration/logSync/LogSyncLayout';
import NozomiReconciliationContainer from '@totem/components/administration/reconciliation/nozomi/NozomiReconciliationContainer';
import NozomiReconciliationTabs from '@totem/components/administration/reconciliation/nozomi/NozomiReconciliationTabs';
import VantageAssetCountsContainer from '@totem/components/administration/reconciliation/nozomi/vantage/VantageAssetCountsContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminAPIs = (userProfile: UserProfile) => {
  const API_SITES = {
    key: 'apiSites',
    title: 'API Sites',
    label: 'API Sites',
    description: 'API Site Management',
    route: '/dashboard/admin/apiSites',
    content: (
      <ApiSitesContainer>
        <IBCard isCovered title="API Sites" extra={<ApiSitesExtra />}>
          <ApiSitesLayout />
        </IBCard>
      </ApiSitesContainer>
    ),
    icon: <ApiOutlined />,
    hasPermissions: () => {
      return permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
      );
    },
  };

  const API_CONNECTIONS = {
    key: 'apiConnections',
    title: 'API Connections',
    label: 'API Connections',
    description: 'API Connection Management',
    route: '/dashboard/admin/apiConnections',
    content: (
      <ApiConnectionsContainer>
        <IBCard
          isCovered
          title="API Connections"
          extra={<ApiConnectionsExtra />}
        >
          <ApiConnectionsLayout />
        </IBCard>
      </ApiConnectionsContainer>
    ),
    icon: <ApiFilled />,
    hasPermissions: () => {
      return permissions.configurationAdministrator.hasPermissions(userProfile);
    },
  };

  const API_LOG_SYNC = {
    key: 'apiLogSync',
    title: 'Log Sync',
    label: 'Log Sync',
    description: 'Log Sync Result History',
    route: '/dashboard/admin/logSync',
    content: (
      <InputContainer
        filterConfig={logSyncContainerConfiguration}
        defaultSort={{ field: 'createdAt', direction: 'descend' }}
        defaultPageSize={20}
        componentKey={'dashboard.admin.logSync'}
        componentLabel={'Admin: Log Sync Results'}
      >
        <LogSyncContainer>
          <IBCard isCovered title="Log Sync Results" extra={<LogSyncExtra />}>
            <LogSyncLayout />
          </IBCard>
        </LogSyncContainer>
      </InputContainer>
    ),
    icon: <ImportOutlined />,
    hasPermissions: () => {
      return permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
      );
    },
  };

  const NOZOMI_RECONCILIATION = {
    key: 'nozomiReconciliation',
    title: 'Nozomi Reconciliation',
    label: 'Nozomi Reconciliation',
    description: 'Reconcile Nozomi Vantage assets with portal devices',
    route: '/dashboard/admin/reconciliation/nozomi',
    content: (
      <NozomiReconciliationContainer>
        <VantageAssetCountsContainer>
          <NozomiReconciliationTabs />
        </VantageAssetCountsContainer>
      </NozomiReconciliationContainer>
    ),
    icon: <ReconciliationOutlined />,
    hasPermissions: () => {
      return permissions.internal.hasPermissions(userProfile);
    },
  };

  const items: IBMenuItem[] = [
    API_CONNECTIONS,
    API_SITES,
    API_LOG_SYNC,
    NOZOMI_RECONCILIATION,
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
